export const pageLikeContentTypesCacheKeyPrefixMap = {
  article: 'getFullArticleBySlug-articles/',
  page: 'getPageByCodename-',
  home_page: 'home_page_slug',
  coach: 'getFullCoachBySlug-',
  event_page: 'getEventPageBySlug-attend/',
  reward: 'getFullRewardBySlug-rewards-and-benefits/',
};

export const ITEM_BY_CODENAME_CACHE_KEY_PREFIX = 'kontent-itemByCodename-';
export const ITEM_WITH_LINKED_ITEMS_CACHE_KEY_PREFIX = 'kontent-itemWithLinkedItems-';
